// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__383kv","col":"styles_col__1LDiw"};